import { GtmLobbyName } from "@obg/gtm.types/adaptive";

import { CORE_ROUTE } from "../route";

import { TrackingData } from "./tracking-area/tracking-area.model";

const CORE_LOBBY_TRACKING_DATA = {
	home: {
		lobbyName: GtmLobbyName.Home,
		lobby: true,
	},
	promotion: {
		lobbyName: GtmLobbyName.Promotions,
	},
	login: {
		lobbyName: GtmLobbyName.Generic,
		maskedQueryParams: { username: "user" },
	},
	forgotPassword: {
		lobbyName: GtmLobbyName.Generic,
		maskedQueryParams: { username: "user@email.com" },
	},
	resetPassword: {
		lobbyName: GtmLobbyName.Generic,
		maskedParams: {
			email: "user@email.com",
			token: "00000-00000-0000",
		},
	},
	resetPasswordByCredentials: {
		lobbyName: GtmLobbyName.Generic,
		maskedQueryParams: { username: "user" },
	},
	resetPasswordByToken: {
		lobbyName: GtmLobbyName.Generic,
		maskedParams: { token: "00000-00000-0000" },
	},
	registerSuccess: {
		lobbyName: GtmLobbyName.Generic,
		maskedQueryParams: { username: "user" },
	},
	activateAccount: {
		lobbyName: GtmLobbyName.Generic,
		maskedParams: { token: "00000-00000-0000" },
	},
	activateAccountWithEmail: {
		lobbyName: GtmLobbyName.Generic,
		maskedParams: {
			email: "user@email.com",
			token: "00000-00000-0000",
		},
	},
	register: {
		lobbyName: GtmLobbyName.Register,
	},
};

export const CORE_TRACKING_DATA: Record<string, TrackingData> = {
	[CORE_ROUTE.home]: CORE_LOBBY_TRACKING_DATA.home,

	[CORE_ROUTE.auth.login]: CORE_LOBBY_TRACKING_DATA.login,
	[CORE_ROUTE.auth.suspiciousLogin]: CORE_LOBBY_TRACKING_DATA.login,

	[CORE_ROUTE.registration.register]: CORE_LOBBY_TRACKING_DATA.register,
	[CORE_ROUTE.registration.registerSuccess]: CORE_LOBBY_TRACKING_DATA.registerSuccess,
	[CORE_ROUTE.registration.activateAccount]: CORE_LOBBY_TRACKING_DATA.activateAccount,
	[CORE_ROUTE.registration.activateAccountWithEmail]: CORE_LOBBY_TRACKING_DATA.activateAccountWithEmail,

	[CORE_ROUTE.promotions.root]: CORE_LOBBY_TRACKING_DATA.promotion,
	[CORE_ROUTE.promotions.groups]: CORE_LOBBY_TRACKING_DATA.promotion,
};
